
<div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-11 col-lg-9 col-xl-8">
        <h2 class="card-title section-title">Get Featured on the page<span class="wow"></span></h2>
      <div class="card banner-form">
          
        <div class="card-body">
          <form autocomplete="off"  autocomplete="off">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="">Full Name <span class="asterisk"></span></label>
                <input type="text"  id="name" name="name" class="form-control" placeholder="Please enter your full name"  maxlength="40">
                <!-- <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                    Invalid full name
                  </div>
                  <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                    Full name is mandatory
                </div>                -->
              </div>
              <div class="form-group col-md-6">
                <label for="">Email Address  <sup>(optional)</sup><span class="asterisk"></span></label>
                <input type="text" (keydown.space)="$event.preventDefault();"  id="email" name="email" class="form-control" placeholder="Your email id" maxlength="50">
                <!-- <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
                    Invalid email id
                </div> -->
              </div>
            <div class="form-group col-md-6">
                <label for="">Your Social URL <span class="asterisk"></span></label>
                <input type="text" (keydown.space)="$event.preventDefault();" class="form-control" id="social_url" name="social_url" placeholder="Enter link to your Facebook or Twitter account">
                <!-- <div class="errormsg" *ngIf="urlValidateMessage == 'required'">
                Social URL is mandatory
                </div>
                <div class="errormsg" *ngIf="urlValidateMessage == 'invalid'">
                    Invalid social URL
                </div> -->
            </div>
            <div class="form-group custom-dropdown col-md-6">
                <label for="">RM Name <sup>(optional)</sup></label>
               <input type="text"  id="rm_name" name="rm_name" class="form-control" placeholder="Enter name of your relationship manager"  maxlength="40">
                <!-- <div class="errormsg" *ngIf="rmValidateMessage == 'lengthError'">
                    Invalid RM name
                  </div>             -->
            </div>
  
            <div class="form-group col-md-6">
                <label for="">Mobile Number <span class="asterisk"></span></label>
                <input type="text" (keydown.space)="$event.preventDefault();"   id="mobile" name="mobile" class="form-control" placeholder="Enter your mobile no." minlength="10" maxlength="10" pattern="[6789][0-9]{9}">
                <!-- <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                    10 digit mobile number is mandatory
                </div>
                <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                  Invalid mobile number
                </div>
                <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                   Mobile number is mandatory
                </div> -->
            </div>
             
              <div class="form-group custom-dropdown col-md-6">
                <label for="">City <span class="asterisk"></span></label>
                <select class="selected-item  form-control" id="city" name="city">
                  <option value="">Pick a city</option>
                  <!-- <ng-container *ngFor="let city of cityArr">
                    <option value='{{city.Id}}'>{{city.name}}</option>
                  </ng-container> -->
                </select>
                <!-- <div class="errormsg" *ngIf="cityValidateMessage == 'required'">
                  City selection is mandatory
                </div> -->
              </div>
              <div class="form-group col-12">
                <label for="">YOUR TESIMONIAL <span class="asterisk"></span></label>
                <textarea id="testimonial" name="testimonial" class="form-control" maxlength="250" placeholder="Please type in your testimonial below" appNoScriptTag></textarea>
                <!-- <div class="errormsg" *ngIf="testimobialValidateMessage == 'required'">
                  Testimonial is mandatory
                </div> -->
              </div> 
              <div class="text-center col-12">
                <button type="submit" class="btn btn-primary">Continue</button>
                <div class="form-group text-center col-12">
                  By continuing, you provide consent and agree to our <a href="../../assets/terms-and-conditions.pdf" target="_blank">Terms & Conditions.</a>
                </div>
              </div>
            </div>
            </form>           
        </div>
            <!--OTP FORM START-->
        <!-- <div class="card-body  otp-card" *ngIf="isOtpFormVisible">
            <form #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)">         
              <p><a href="javascript:void(0)" id="btn-back" (click)="changeNumber()"><i class="fa fa-chevron-left"></i> Change Number</a></p>
              <div class="alert alert-success"><i class="fa fa-check"></i> <span>OTP successfully sent on number
                  {{displayMobile}}</span>
              </div>
  
            <div class="form-group">
                <input type="text" (keydown.space)="$event.preventDefault();"  id="otp" name="otp" class="form-control" maxlength="6" placeholder="Enter OTP"  >
                <div class="errormsg" *ngIf='!otpVerifiedStatus'>
                  Invalid OTP
                </div>
                <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                  Please enter OTP to continue.  
              </div>
              <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">Invalid OTP </div>
            </div>
            <div class="form-group text-center">
                <button type="submit" class="btn btn-primary">Submit</button>
            </div>
            
              <div class="form-group text-center">
                <p class="timer">Didn't recieve OTP? Resend in <strong style="font-size:17px;">30 </strong> seconds</p>
                <a class="resendotp" href="javascript:void(0)">Resend OTP</a>
              </div>
        </form>
      </div> -->
    <div class="card-body success-card">
        <div class="success-tick">
            <h2>Thank you!</h2>
        </div>
       <h6>Your query has been successfully submitted. We will get in touch with you shortly.</h6>
    </div>
        </div>
      </div>
    </div>
  </div>
  